import { getString } from "config-api";

export const WEB_AB_TESTS_URL = getString("Client.stats.urlABTestsConfig");

export const DEFAULT_AB_VARIANT = "A";
